import { SwiperSlide } from "swiper/react";
import useTranslation from "next-translate/useTranslation";
import Slider from "@/components/common/Slider";
import AboutCard from "@/components/become-consultant/AboutCard";

const WhyVialantis = ({ whyVialantis = [] }) => {
  const { t } = useTranslation("become-consultant");

  return (
    <section className="container pt-16 pb-4 lg:py-16">
      <h2 className="text-center text-xl font-semibold lg:text-4xl">{t`why-vialantis.title`}</h2>
      <p className="mt-2 text-center text-xs text-grey-700 lg:mt-3 lg:text-base">{t`why-vialantis.subtitle`}</p>
      <div className="lg:mt-12">
        <Slider>
          {whyVialantis.map((about) => (
            <SwiperSlide key={about.id} className="!h-auto py-4 lg:py-8">
              <AboutCard about={about} />
            </SwiperSlide>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default WhyVialantis;
